// extracted by mini-css-extract-plugin
export var table = "_yw-0";